import { render, staticRenderFns } from "./ManagedListsIndex.vue?vue&type=template&id=62ee48c7"
import script from "./ManagedListsIndex.vue?vue&type=script&lang=js"
export * from "./ManagedListsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports